import { useState } from "react"
import { Button } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { useWebProvider } from "../../hooks/defaults/useWebProvider"
import { endPointCaderno, paths } from "../../models/constantes"
import AutoComplete from "../default-components/forms/AutoComplete"
import FormField from "../default-components/forms/FormField"
import SaveDeleteButtons from "../default-components/buttons/SaveDeleteButtons"
import RecursoSelector from "./RecursoSelector"

const LinhaDePlanoDeControleFormV2 = ({ onChange, lpc }) => {


    const { controller } = useWebProvider()
    const [formData, setFormData] = useState(lpc ? lpc : {})
    const navigate = useNavigate()

    const onOperacaoUpdate = (operacao) => {
        let updated = {
            ...formData,
            operacao,
            operacaoId: operacao.id
        }
        setFormData(updated)
        onChange?.(updated)

    }

    const onRecursoUpdate = (selected) => {
        let updated = {
            ...formData,
            recursoId: selected?.id,
            recurso: selected
        }
        setFormData(updated)
        onChange?.(updated)
    }

    const onUpdatePosicao = (nextPosition) => {
       
        let updated = {
            ...formData,
            oldPos :  formData.posicao ? formData.posicao : 1,
            newPos: nextPosition,
            posicao: nextPosition
        }

        setFormData(updated)
         if(!nextPosition) return
        onChange?.(updated)

    }

     




    return (
        <>
            <FormField label="Posicao" posicao val={formData.posicao} onValueUpdate={onUpdatePosicao} />
            <AutoComplete
                title={"Operacao"}
                displayKeys={["descricao"]}
                sortKey={"descricao"}
                value={formData.operacao?.descricao}
                onSelectedClick={onOperacaoUpdate}
                loadCondition={true}
                loadFunc={() => controller(null, endPointCaderno).get("operacao")}
            />
            <RecursoSelector
                value={formData.recurso}
                onSelect={onRecursoUpdate}
            />
           


        </>
    )
}

export default LinhaDePlanoDeControleFormV2